import styled from "styled-components";
import Footer from "../Footer/footer"
import Navigation from "../navigation/header"

function Contact() {

  return (
    <>
     <Navigation />
      <Main>
        <IframeContainer>
            <Iframe
              src="https://easy-donate.ck.page/d2b58dcce1"
              frameBorder="0"
              allowFullScreen
            />
          </IframeContainer>
      </Main>
      <><Footer/></>
     </>
  );
}



const Main = styled.main`
  display: flex;
  justify-content: center;
  padding: 0px;
  overflow-x: hidden; 
  overflow-y: hidden;
  padding-top:  120px;
  background-color: #f0eceb;
  @media (max-width: 991px) {
  padding-top:0px;
  }
`;

const FormTitle = styled.h1`
  font-family: 'Montserrat', sans-serif;
  font-size: 32px;
  font-weight: 700;
  color: #020f12;
  text-align: center;
  letter-spacing: -0.32px;
  @media (max-width: 991px) {
    max-width: 100%;
  }
  `;

const IframeContainer = styled.div`
  
  width: 100%;
  height: 700px;  
  display: flex;
  justify-content: center;
  overflow:hidden;
  @media (max-width: 601px) {
  height: 1020px;  
  }
`;

const Iframe = styled.iframe`
  width: 100%;
  height: 100%;
  border: none;
  border-radius: 8px;
`;
export default Contact;
